// extracted by mini-css-extract-plugin
export default {"didntReinvent":"styles_didntReinvent__FlLP-","didntReinventText":"styles_didntReinventText__Puwo4","background":"styles_background__6KbTh","violetText":"styles_violetText__dq7sx"};